import { createAction } from '@reduxjs/toolkit';
import { GET_DICTIONARIES_LANGUAGES } from '../actionConstants';

export const getAllLanguagesAction = createAction(GET_DICTIONARIES_LANGUAGES);
